// Email 포맷 형식 체크
const EmailFormatCheck = (email) => {
    // 이메일 정규 표현식
    var emailRegex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
    if (!emailRegex.exec(email)) {
      alert("이메일을 형식에 맞게 입력해 주세요.")
      return false
    } else {
      return true
    }
  };
  
  // 생년월일 포맷 형식 체크
  const birthDayFormatCheck = (birthDay) => {
    // 이메일 정규 표현식
    var birthDayRegex = /\d{6}/i
    if (!birthDayRegex.exec(birthDay)) {
      alert("생년월일은 앞 6자리 숫자로 입력해 주세요.")
      return false
    } else {
      return true
    }
  };
  
  // 전화번호 포맷 형식 체크
  const PhoneFormatCheck = (phoneNumber) => {
    // 전화번호 정규 표현식
    var regex = /^\d{2,3}-\d{3,4}-\d{4}$/
    if (!regex.exec(phoneNumber)) {
      alert('연락처를 정확히 입력해 주세요.')
      return false
    } else {
      return true
    }
  };
  
  // 빈값 체크
  const EmptyCheck = (value, text) => {
    console.log('value', value)
    if (value.trim() === '') {
      alert(text + ' 입력 해 주세요.')
      return false
    } else {
      return true
    }
  };
  
  export { EmailFormatCheck, PhoneFormatCheck, birthDayFormatCheck, EmptyCheck }